export const INITIALIZE_APP = 'INITIALIZE_APP';
export const INITIALIZE_APP_SUCCESS = 'INITIALIZE_APP_SUCCESS';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
export const ACCESS_TOKEN_REFRESH = 'ACCESS_TOKEN_REFRESH';
export const LOAD_APP_NAME_SUCCESS = 'LOAD_APP_NAME_SUCCESS';